export default __webpack_public_path__ + "static/media/LolChampionGalleryVideo_1.23eafcab.webm";